/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyWhiteLabelTemplate,
    ReadOnlyWhiteLabelTemplateFromJSON,
    ReadOnlyWhiteLabelTemplateFromJSONTyped,
    ReadOnlyWhiteLabelTemplateToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20049
 */
export interface InlineResponse20049 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20049
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20049
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20049
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyWhiteLabelTemplate>}
     * @memberof InlineResponse20049
     */
    results: Array<ReadOnlyWhiteLabelTemplate>;
}

export function InlineResponse20049FromJSON(json: any): InlineResponse20049 {
    return InlineResponse20049FromJSONTyped(json, false);
}

export function InlineResponse20049FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20049 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyWhiteLabelTemplateFromJSON)),
    };
}

export function InlineResponse20049ToJSON(value?: InlineResponse20049 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyWhiteLabelTemplateToJSON)),
    };
}


